export class EntrepriseDroit {
    static jsonMap = {
        id: { key: 'idEntreprise', optional: true },
        droitRecolte: { key: 'droitRecolte', optional: true },
        droitEcoulement: { key: 'droitEcoulement', optional: true },
        droitStock: { key: 'droitStock', optional: true }
    };

    public id: number;
    public droitRecolte: boolean;
    public droitEcoulement: boolean;
    public droitStock: boolean;

    constructor() {}
}
